import { ProjectInfo } from '@frontend-site/shared/data';
import { MenuItem } from '../../../models';
import { MENU_IDS } from '../../menu-ids';

export function createDiscoveryMenu(projectInfo: ProjectInfo, isForesightModuleNewUi: boolean): MenuItem | null {
    if (projectInfo.isRestrictedApp()) {
        return null;
    }
    if (!projectInfo.isSalesforceProject()) {
        return null;
    }

    const routePath = isForesightModuleNewUi ? `/foresight/${projectInfo.id}` : `/tm/${projectInfo.id}/discovery`;
    return {
        id: MENU_IDS.PROJECT.DISCOVERY,
        label: 'Enumerations.ApplicationModules.DISCOVERY',
        routePath,
        settings: { reload: true, icon: 'plus-circle', cssClasses: 'p-nav-item-hover-like' }
    };
}
